<template lang="pug">
site-list(
    platformType="in-app"
    :sites="apps"
    :isRemainingSites="isRemainingApps"
    :deletingErrors="deletingErrors"
    :filters="filters"
    @update-status="updateStatus"
    @update-search-string="updateSearchString"
    @more-sites="moreSites"
    @close-error-popup="closeErrorPopup"
)
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import siteList from '@/components/site_elements/SiteList.vue'

export default {
    name: 'Apps',
    components: {
        siteList,
    },
    data() {
        return {
            filterProccessing: false,
            filters: {
                status: 'all',
                searchString: '',
            },
        }
    },
    computed: {
        ...mapGetters('Placement', ['deletingErrors']),
        ...mapGetters('Sites', ['apps', 'isRemainingApps', 'isFetchingSites']),
        ...mapGetters('Refbooks', ['refbooksLoaded']),
        lastSiteId() {
            if (this.apps.length > 0) {
                return this.apps[this.apps.length - 1].site_id
            } else {
                return 0
            }
        },
    },
    methods: {
        ...mapActions('Sites', ['fetchSites', 'cleanApps']),
        ...mapActions('Placement', ['cleanError']),

        moreSites() {
            this.fetchSites({
                lastSiteId: this.lastSiteId,
                status: this.filters.status,
                searchString: this.filters.searchString,
                platformType: 'in-app',
            })
        },
        closeErrorPopup() {
            this.cleanError()
        },
        updateStatus(value) {
            this.cleanApps()
            this.filters.status = value
            this.fetchSites({
                lastSiteId: this.lastSiteId,
                status: this.filters.status,
                searchString: this.filters.searchString,
                platformType: 'in-app',
            })
        },
        updateSearchString(value) {
            this.filters.searchString = value
            if (!this.filterProccessing) {
                this.filterProccessing = true
            }
        },
    },
    watch: {
        filterProccessing(newVal) {
            if (newVal) {
                setTimeout(() => (this.filterProccessing = false), 2000)
            } else {
                this.cleanApps()
                this.fetchSites({
                    lastSiteId: this.lastSiteId,
                    status: this.filters.status,
                    searchString: this.filters.searchString,
                    platformType: 'in-app',
                })
            }
        },
        refbooksLoaded: {
            handler: function (newVal) {
                if (newVal && !this.isFetchingSites) {
                    this.fetchSites({
                        lastSiteId: 0,
                        status: 'all',
                        searchString: '',
                        platformType: 'in-app',
                    })
                }
            },
            immediate: true,
        },
    },
}
</script>

<style scoped lang="stylus"></style>
